import type { IconData } from '@stacksjs/iconify-core'

export const arrowCircleDown: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m7.293 12.707l4 4a1.004 1.004 0 0 0 1.414 0l4-4a1 1 0 0 0-1.414-1.414L13 13.586V8a1 1 0 0 0-2 0v5.586l-2.293-2.293a1 1 0 0 0-1.414 1.414\"/><path fill=\"currentColor\" d=\"M12 22A10 10 0 1 0 2 12a10.01 10.01 0 0 0 10 10M7.293 11.293a1 1 0 0 1 1.414 0L11 13.586V8a1 1 0 0 1 2 0v5.586l2.293-2.293a1 1 0 0 1 1.414 1.414l-4 4a1.004 1.004 0 0 1-1.414 0l-4-4a1 1 0 0 1 0-1.414\" opacity=\".5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default arrowCircleDown
